export default {
  CurrencySelector__ARIA_LABEL: "Select currency type",
  CurrencySelector__CURRENCY: "Currency",
  CurrencySelector__DOLLARS: "Dollars",
  CurrencySelector__DOLLARS_ARIA_LABEL: "Select dollars currency",
  CurrencySelector__DOLLARS_PLUS_POINTS: "$ + Points",
  CurrencySelector__DOLLARS_PLUS_POINTS_ARIA_LABEL: "Select dollars plus points currency",
  CurrencySelector__POINTS: "Points",
  CurrencySelector__POINTS_ARIA_LABEL: "Select points currency",
};
